import Request from '../../../../src/core/gd/data/request'

export default class ApiDocumentType {

    static create(name:string, icon:string, description:string) {

        return new Request(this, 'POST', 'company/'+gd.companyId+'/note-types', {
            companyId       : gd.companyId,
            name            : name,
            icon            : icon,
            description     : description,
            // template        : template,
            // templateRTF     : templateRTF
        });

    }




}